

import type { ReactNode } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

import Spinner from "../loader/ButtonSpinner";

interface GxBlackButtonLinkProps {
  label?: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  children?: ReactNode;
  loadingLabel?: string;
}

const GxBlackButtonLink: React.FC<GxBlackButtonLinkProps> = ({
  onClick,
  label = "Apply",
  children,
  loading = false,
  disabled = false,
  loadingLabel,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!loading && !disabled) {
      onClick();
    }
  };

  const getButtonText = () => {
    if (loading) {
      return loadingLabel || children || "";
    }
    return children || "";
  };
  return (
    <Button
      onClick={handleClick}
      disabled={disabled || loading}
      className="gx-dialog-back-button-link gx-h4-eb"
    >
      {loading && <Spinner />}
      <span className="gx-p12-m">{getButtonText()}</span>
    </Button>
  );
};

export default GxBlackButtonLink;
